import PointLayer from "./PointLayer";


const PARKING_COLORS = [{
    color: 'rgb(0,199,7)',
    color2: 'rgba(0,199,7,0)'
},{
    color: 'rgb(255,179,0)',
    color2: 'rgba(255,179,0,0)'
},{
    color: 'rgb(212,0,0)',
    color2: 'rgba(212,0,0,0)'
}];
export default class ParkingLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Parking', options = {scale: 0.2});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });
        let _scale = info.used / info.total;
        let _color = _scale > 0.8 ? PARKING_COLORS[2] : (_scale > 0.4 ? PARKING_COLORS[1] : PARKING_COLORS[0]);
        node.a({
            name: info.name,
            price: info.price,
            total: info.total,
            used: info.used,
            remain: info.remain,
            color: _color.color,
            color2: _color.color2
        });
        node.setDataBindings({
            "a": {
                "n_total": {
                    "id": "$zs3d_parking_n_total"
                },
                "n_used": {
                    "id": "$zs3d_parking_n_used"
                },
                "n_remain": {
                    "id": "$zs3d_parking_n_remain"
                },
                "n_inNumber": {
                    "id": "$zs3d_parking_n_inNumber"
                },
                "n_outNumber": {
                    "id": "$zs3d_parking_n_outNumber"
                },
                "n_faultNumber": {
                    "id": "$zs3d_parking_n_faultNumber"
                },
            }
        });
    }

    showLayer() {
        super.show();
        this.startLayerAnim();
    }

    hideLayer() {
        super.hide();
        this.stopLayerAnim();
    }

    startLayerAnim() {
        this.parkingStep = parseInt(Math.random() * 10 - 5);
        if(!this.parkingAnim) {
            const params = {
                delay: 3000,
                duration: 2000,
                easing: t => t,
                finishFunc: () => {
                    this.parkingStep = parseInt(Math.random() * 10 - 5);
                    this.nodes.forEach(node => {
                        let info = node.a('properties');
                        info.used = node.a('used');
                        info.remain = node.a('remain');
                        node.a({
                            properties: info,
                            inNumber: parseInt(Math.random() * 30) + 80,
                            outNumber: parseInt(Math.random() * 40) + 60,
                            faultNumber: parseInt(Math.random() * 30),
                        });
                    });
                    this.parkingAnim = ht.Default.startAnim(params);
                },
                action: v => {
                    this.nodes.forEach(node => {
                        const properties = node.a('properties');
                        let step = ((properties.used +  this.parkingStep) > properties.total || (properties.used +  this.parkingStep) < 0) ? -this.parkingStep : this.parkingStep;
                        
                        // let _scale = (properties.used + step * v) / properties.total;
                        // let _color = _scale > 0.8 ? PARKING_COLORS[2] : (_scale > 0.4 ? PARKING_COLORS[1] : PARKING_COLORS[0]);
                        node.a({
                            used: properties.used + parseInt(step * v),
                            remain: properties.remain - parseInt(step * v),
                            // color: _color.color,
                            // color2: _color.color2
                        });
                    });
                }
            };
            this.parkingAnim = ht.Default.startAnim(params);
        }
    }

    stopLayerAnim() {
        if(this.rentparkingAnimAnim) {
            this.parkingAnim.pause();
            this.parkingAnim = null;
        }
    }

}